// extracted by mini-css-extract-plugin
export default {"price":"SpecialistPrice_price__hSgYM","center":"SpecialistPrice_center__kPbaU","end":"SpecialistPrice_end__7RMbi","start":"SpecialistPrice_start__xWts6"};